var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseFormItem',{attrs:{"label":"发票抬头","isError":_vm.isError,"isErrorBlink":_vm.isErrorBlink}},[_c('InvoiceList',_vm._g(_vm._b({ref:"bill_id",on:{"change":_vm.handleChange}},'InvoiceList',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }